import store from '../.././store';

export async function saveEmailToDb(email) {
    const emailJson = email
    emailJson.placeholders = store.state.xPathPlaceholders
    emailJson.folderId = store.state.currentFolder
    emailJson.media = store.state.mediaQueries
    const response = await fetch('https://html-creator.demo.cartago.com/api/save-email', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(emailJson),
    });
    const result = await response.json();
    console.log(result.message);
    console.log(emailJson)
  }
  